import { eventHasRun } from '../../utils/eventTracker';

export const DDC_LINK_CLICKTOCALL = 'ddc.link.clickToCall';

function clickToCall({ currentTarget: element, timeStamp }) {
	let eventObject;
	const $element = $(element);

	if (
		!eventHasRun(DDC_LINK_CLICKTOCALL, {
			timeStamp
		})
	) {
		eventObject = {
			eventType: DDC_LINK_CLICKTOCALL,
			eventData: {
				clickToCallDepartment: $element
					.closest('[data-click-to-call]')
					.data('click-to-call'),
				phoneNumber: $element
					.closest('[data-click-to-call]')
					.data('click-to-call-phone'),
				element
			}
		};
	}

	return eventObject;
}

export default clickToCall;
